import { render, staticRenderFns } from "./sideView.vue?vue&type=template&id=13452fc4"
import script from "./sideView.vue?vue&type=script&lang=js"
export * from "./sideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports